export const PAGE = 1;
export const PAGE_SIZE = 10;
export const ORDER = 'descend';
export const PAGINATION = {
    page: PAGE,
    pageSize: PAGE_SIZE,
    order: ORDER,
    total: 0,
    data: [],
    loading: false
};
export const FILTER = {
    page: PAGE,
    pageSize: PAGE_SIZE,
    order: ORDER,
    field: ''
};